export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const EDIT_QUANTITY = 'EDIT_QUANTITY';
export const EDIT_ITEM = 'EDIT_ITEM';
export const UPDATE_CART_TOTALS = 'UPDATE_CART_TOTALS';
export const UPDATE_STATE = 'UPDATE_STATE';
